"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyTradingData = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var record_1 = require("../../model/record");
var service_1 = require("../../../library/base/service");
var MyTradingData = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(MyTradingData, _super);
    function MyTradingData() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '我的交易记录';
        _this.code = '101048';
        _this.desc = '我的交易记录';
        _this.requestParams = new record_1.MyTradingDataRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return MyTradingData;
}(service_1.BaseService));
exports.MyTradingData = MyTradingData;
//# sourceMappingURL=myTradingData.js.map